module.exports = __webpack_public_path__ + "static/media/5-2.4ef945bc.mp3";